import React, { FC } from 'react';
import { RouteComponentProps, Route, Switch } from 'react-router';
import urlJoin from 'url-join';
import { Create, List, View } from './screens';
import { CommissionsProvider } from './services/providers';

export const Router: FC<RouteComponentProps> = ({ match }) => {
  return (
    <CommissionsProvider>
      {() => (
        <Switch>
          <Route path={urlJoin(match.url, '/')} component={List} exact={true} />
          <Route
            path={urlJoin(match.url, '/create')}
            component={Create}
            exact={true}
          />
          <Route path={urlJoin(match.url, '/:id')} component={View} />
        </Switch>
      )}
    </CommissionsProvider>
  );
};
